













import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramite from "@/models/tipoTramite";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import Helpers from "@/helpers/helper";
import ReclamoModel from "@/models/tramite/reclamo/reclamo.model";

@Component
export default class TramiteBeneficiarioReclamo extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  @Prop() readonly title!: string;

  model: ReclamoModel;
  descripcion: any;
  constructor() {
    super();
    this.model = new ReclamoModel();
  }
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }

  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }
  created() {
    let props = [];
    props.push(new TipoTramiteComponentProp("title", "string", true, "Título"));
    this.$emit("render", props);
  }

  @Watch("model", { deep: true })
  set(model: ReclamoModel) {
    if (this.content) {
      let contenido = this.content as any;
      contenido.descripcionReclamo = model.descripcion;
      contenido.telefonoReclamo = Helpers.Filters.PhoneToStr(model.telefono);
      this.$emit("update:content", contenido);
    }
  }
}
